// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orders-container {
    margin: 20px 0;
    padding: 0 20px;
}

.orders-header {
    margin-bottom: 20px;
}

.orders-title {
    font-size: 24px;
    margin-bottom: 20px;
    text-align: center;
    font-family: "Rigidica Text Regular", sans-serif;
}

.orders-controls {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 20px;
}

.orders-search {
    flex: 1 1;
}

.orders-search-input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    outline: none;
}

.orders-filters {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
}

.orders-filter-select {
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    background-color: white;
    outline: none;
}

.orders-archive-filter {
    display: flex;
    align-items: center;
    gap: 5px;
}

.orders-reset-button {
    padding: 8px 15px;
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s;
}

.orders-reset-button:hover {
    background-color: #e5e5e5;
}

.orders-table-container {
    overflow-x: auto;
    margin-bottom: 20px;
}

.orders-table {
    width: 100%;
    border-collapse: collapse;
}

.orders-table th,
.orders-table td {
    padding: 12px 15px;
    text-align: left;
    border-bottom: 1px solid #ddd;
    vertical-align: middle;
}

.orders-table th {
    background-color: #f5f5f5;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s;
    white-space: nowrap;
}

.orders-table th:hover {
    background-color: #e8e8e8;
}

.orders-sort-active {
    background-color: #e0e0e0;
}

.orders-sort-indicator {
    font-size: 12px;
    display: inline-block;
    margin-left: 3px;
}

.orders-item:hover {
    background-color: #f9f9f9;
}

.orders-item-archived {
    background-color: #f0f0f0;
    color: #777;
}

.orders-id {
    font-weight: bold;
    color: #333;
    outline: none;
    transition: color 0.3s ease;
}

.orders-item-archived .orders-id {
    color: #777;
    transition: color 0.3s ease;
}

.orders-id:hover {
    color: #555;
}

.orders-item-archived .orders-id:hover {
    color: #555;
}

.orders-address-preview {
    font-size: 12px;
    color: #666;
    margin-top: 3px;
}

.orders-status-dropdown {
    padding: 5px;
    border-radius: 4px;
    border: 1px solid #ddd;
    font-size: 14px;
    width: 100%;
    min-width: 100px;
    outline: none;
}

.orders-status-pending {
    background-color: #fff3cd;
    color: #856404;
}

.orders-status-shipped {
    background-color: #d4edda;
    color: #155724;
}

.orders-status-returned {
    background-color: #f8d7da;
    color: #721c24;
}

.orders-total {
    font-weight: bold;
    white-space: nowrap;
}

.orders-actions {
    display: flex;
    gap: 5px;
    flex-wrap: nowrap;
    justify-content: flex-start;
    min-width: 200px;
}

.orders-view-button,
.orders-archive-button,
.orders-unarchive-button,
.orders-delete-button {
    padding: 6px 10px;
    border: none;
    border-radius: 4px;
    font-size: 13px;
    cursor: pointer;
    transition: background-color 0.3s;
    flex: 1 1;
    white-space: nowrap;
    text-align: center;
}

.orders-view-button {
    background-color: #333;
    color: white;
}

.orders-view-button:hover {
    background-color: #555;
}

.orders-archive-button {
    background-color: #6c757d;
    color: white;
}

.orders-archive-button:hover {
    background-color: #5a6268;
}

.orders-unarchive-button {
    background-color: #28a745;
    color: white;
}

.orders-unarchive-button:hover {
    background-color: #218838;
}

.orders-delete-button {
    background-color: #dc3545;
    color: white;
}

.orders-delete-button:hover {
    background-color: #c82333;
}

.orders-no-orders,
.orders-no-results {
    text-align: center;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 6px;
    font-style: italic;
    color: #666;
}

.orders-loading {
    text-align: center;
    padding: 20px;
    color: #666;
}

.orders-error {
    color: #ff0000;
    margin-bottom: 15px;
    text-align: center;
    padding: 10px;
    background-color: #ffeeee;
    border: 1px solid #ff0000;
    border-radius: 4px;
}

.orders-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    gap: 10px;
}

.orders-pagination-button {
    background-color: #333;
    color: white;
    border: none;
    padding: 8px 15px;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
    font-family: "Rigidica Text Regular", sans-serif;
    font-size: 14px;
    min-width: 40px;
}

.orders-pagination-button:hover:not(:disabled) {
    background-color: #555;
}

.orders-pagination-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.orders-page-indicator {
    font-family: "Rigidica Text Regular", sans-serif;
    padding: 8px 15px;
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    font-weight: bold;
    min-width: 80px;
    text-align: center;
}

/* Media Queries */

@media (min-width: 768px) {
    .orders-controls {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Orders.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;;;;IAII,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;IACjC,SAAO;IACP,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,gDAAgD;IAChD,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gDAAgD;IAChD,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA,kBAAkB;;AAElB;IACI;QACI,mBAAmB;QACnB,8BAA8B;QAC9B,mBAAmB;IACvB;AACJ","sourcesContent":[".orders-container {\n    margin: 20px 0;\n    padding: 0 20px;\n}\n\n.orders-header {\n    margin-bottom: 20px;\n}\n\n.orders-title {\n    font-size: 24px;\n    margin-bottom: 20px;\n    text-align: center;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n}\n\n.orders-controls {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    margin-bottom: 20px;\n}\n\n.orders-search {\n    flex: 1;\n}\n\n.orders-search-input {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n    outline: none;\n}\n\n.orders-filters {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    align-items: center;\n}\n\n.orders-filter-select {\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n    background-color: white;\n    outline: none;\n}\n\n.orders-archive-filter {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.orders-reset-button {\n    padding: 8px 15px;\n    background-color: #f5f5f5;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    transition: background-color 0.3s;\n}\n\n.orders-reset-button:hover {\n    background-color: #e5e5e5;\n}\n\n.orders-table-container {\n    overflow-x: auto;\n    margin-bottom: 20px;\n}\n\n.orders-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.orders-table th,\n.orders-table td {\n    padding: 12px 15px;\n    text-align: left;\n    border-bottom: 1px solid #ddd;\n    vertical-align: middle;\n}\n\n.orders-table th {\n    background-color: #f5f5f5;\n    font-weight: bold;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    white-space: nowrap;\n}\n\n.orders-table th:hover {\n    background-color: #e8e8e8;\n}\n\n.orders-sort-active {\n    background-color: #e0e0e0;\n}\n\n.orders-sort-indicator {\n    font-size: 12px;\n    display: inline-block;\n    margin-left: 3px;\n}\n\n.orders-item:hover {\n    background-color: #f9f9f9;\n}\n\n.orders-item-archived {\n    background-color: #f0f0f0;\n    color: #777;\n}\n\n.orders-id {\n    font-weight: bold;\n    color: #333;\n    outline: none;\n    transition: color 0.3s ease;\n}\n\n.orders-item-archived .orders-id {\n    color: #777;\n    transition: color 0.3s ease;\n}\n\n.orders-id:hover {\n    color: #555;\n}\n\n.orders-item-archived .orders-id:hover {\n    color: #555;\n}\n\n.orders-address-preview {\n    font-size: 12px;\n    color: #666;\n    margin-top: 3px;\n}\n\n.orders-status-dropdown {\n    padding: 5px;\n    border-radius: 4px;\n    border: 1px solid #ddd;\n    font-size: 14px;\n    width: 100%;\n    min-width: 100px;\n    outline: none;\n}\n\n.orders-status-pending {\n    background-color: #fff3cd;\n    color: #856404;\n}\n\n.orders-status-shipped {\n    background-color: #d4edda;\n    color: #155724;\n}\n\n.orders-status-returned {\n    background-color: #f8d7da;\n    color: #721c24;\n}\n\n.orders-total {\n    font-weight: bold;\n    white-space: nowrap;\n}\n\n.orders-actions {\n    display: flex;\n    gap: 5px;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    min-width: 200px;\n}\n\n.orders-view-button,\n.orders-archive-button,\n.orders-unarchive-button,\n.orders-delete-button {\n    padding: 6px 10px;\n    border: none;\n    border-radius: 4px;\n    font-size: 13px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    flex: 1;\n    white-space: nowrap;\n    text-align: center;\n}\n\n.orders-view-button {\n    background-color: #333;\n    color: white;\n}\n\n.orders-view-button:hover {\n    background-color: #555;\n}\n\n.orders-archive-button {\n    background-color: #6c757d;\n    color: white;\n}\n\n.orders-archive-button:hover {\n    background-color: #5a6268;\n}\n\n.orders-unarchive-button {\n    background-color: #28a745;\n    color: white;\n}\n\n.orders-unarchive-button:hover {\n    background-color: #218838;\n}\n\n.orders-delete-button {\n    background-color: #dc3545;\n    color: white;\n}\n\n.orders-delete-button:hover {\n    background-color: #c82333;\n}\n\n.orders-no-orders,\n.orders-no-results {\n    text-align: center;\n    padding: 20px;\n    background-color: #f9f9f9;\n    border-radius: 6px;\n    font-style: italic;\n    color: #666;\n}\n\n.orders-loading {\n    text-align: center;\n    padding: 20px;\n    color: #666;\n}\n\n.orders-error {\n    color: #ff0000;\n    margin-bottom: 15px;\n    text-align: center;\n    padding: 10px;\n    background-color: #ffeeee;\n    border: 1px solid #ff0000;\n    border-radius: 4px;\n}\n\n.orders-pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 20px;\n    gap: 10px;\n}\n\n.orders-pagination-button {\n    background-color: #333;\n    color: white;\n    border: none;\n    padding: 8px 15px;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-size: 14px;\n    min-width: 40px;\n}\n\n.orders-pagination-button:hover:not(:disabled) {\n    background-color: #555;\n}\n\n.orders-pagination-button:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}\n\n.orders-page-indicator {\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    padding: 8px 15px;\n    background-color: #f5f5f5;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n    font-weight: bold;\n    min-width: 80px;\n    text-align: center;\n}\n\n/* Media Queries */\n\n@media (min-width: 768px) {\n    .orders-controls {\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
